<div class="login-wrapper">
  <div class="container">
    <div class="row vertical-offset-100">
      <div class="col-md-4 col-md-offset-4">
        <div class="panel panel-default">
          <div class="panel-heading">
            <div class="row-fluid user-row">
              <img src="assets/img/lgt.png" class="img-responsive" alt="LGT Logo" />
            </div>
          </div>
          <div class="panel-body">
            <form accept-charset="UTF-8" role="form" class="form-signin" (ngSubmit)="login(user)">
              <fieldset>
                <label class="panel-login">
                  <div class="login_result"></div>
                </label>
                <input
                  [(ngModel)]="user.email"
                  style="text-transform: none !important"
                  name="login-username"
                  id="login-username"
                  class="form-control"
                  placeholder="Username"
                  type="text"
                />
                <input
                  [(ngModel)]="user.noHashedpassword"
                  style="text-transform: none !important"
                  name="login-password"
                  id="login-password"
                  class="form-control"
                  placeholder="Password"
                  type="password"
                />
                <input
                  type="submit"
                  name="login-submit"
                  id="login-submit"
                  tabindex="4"
                  class="btn btn-lg btn-login btn-block"
                  value="Login »"
                />
              </fieldset>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
